import {TableOrFormRenderOptionsType} from 'notebook/structured-tables/StructuredTableOrFormOutsideNotebook';
import {BenchlingAction} from 'redux-stores/Action';

import {FormTableSwitcherStatusActionType} from './FormTableSwitcherStateActions';

/**
 * Reducer for tracking the view state (form/table) of structured tables
 */

export type FormTableSwitcherState = Record<string, TableOrFormRenderOptionsType>;

function setFormTableSwitcherStatus(
  state: FormTableSwitcherState,
  tableCid: string,
  switcherStatus: TableOrFormRenderOptionsType
): Record<string, TableOrFormRenderOptionsType> {
  return {
    ...state,
    [tableCid]: switcherStatus,
  };
}

export default function reduceFormTableSwitcherState(
  state: FormTableSwitcherState = {},
  action: BenchlingAction
): FormTableSwitcherState {
  if (action.type === FormTableSwitcherStatusActionType.SET_FORM_TABLE_SWITCHER_STATUS_ACTION) {
    return setFormTableSwitcherStatus(state, action.tableCid, action.switcherStatus);
  }
  return state;
}
